import React from 'react';
import '../Customcss/customerTable.css' // We'll create this CSS file next

const CustomerTable = ({customers,heading,type}) => {
  // Sample customer data

return (
    <div className="customer-table-container">
        <center>
  <h2 className='urdu-text' style={{color:type===1?'red':'green'}}>{heading}</h2>
        </center>
    
      <div className="table-wrapper">
        <table className="customer-table urdu-text">
       <thead>
  <tr >
    <th style={type === 1 ? { color: 'red' } : { color: 'green' }}>نمبر</th>
    <th style={type === 1 ? { color: 'red' } : { color: 'green' }}>گاہک کا نام</th>

    <th style={type === 1 ? { color: 'red' } : { color: 'green' }}>فون نمبر</th>
    {type === 1 ? (
      <th style={type === 1 ? { color: 'red' } : { color: 'green' }}>آرڈر نہیں دیا</th>
    ) : (
      <th style={type === 1 ? { color: 'red' } : { color: 'green' }}>آخری وصولی کی تاریخ</th>
    )}


      {type === 1 ? (
      <th style={type === 1 ? { color: 'red' } : { color: 'green' }}
>
  آخری آرڈر کی تاریخ

      
      </th>
    ) : (
      <th style={type === 1 ? { color: 'red' } : { color: 'green' }}
>
   اختتامی بیلنس      
      </th>
    )}
  
  
  </tr>
</thead>
          <tbody>
            {customers.map((customer, index) => (
              <tr key={customer.id}>
                <td>{index + 1}</td>
                <td>{customer.name}</td>
             
             
                <td>{customer.phone}</td>

                {type===1? <td>

                  {customer.days_inactive
                  }دن سے
                  
                  </td>
                :<td>
{customer.last_payment_date}(دن{customer.days_since_last_payment})

                </td>  
                }

                 {type===1? <td>

                  {customer.last_order_date
                  } 
                  
                  </td>
                :<td>
{customer.outstanding_balance}

                </td>  
                }
               
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;